import React from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Grid, Box } from '@mui/material'
import { ModelAutocompleteField } from '@front/squirtle'

const Row1 = () =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <ModelAutocompleteField
        name='vehicletype_id'
        label={I18n.t('name.label', { count: 1 })}
        model_name={'vehicletype'}
        searchMode='search'
        searchQuery={'contains'}
        autocompleteKey={'name_trkey.fr'}
        labelKeys={['name_translated']}
        loadOnFocus={false}
        clearOnEmpty
      />
    </Grid>
  </Grid>

const SearchForm = () =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Grid size={12}>
        <Typography variant={'h5'}>{I18n.t('vehicletype.search')}</Typography>
      </Grid>
      <Row1 />
    </Grid>
  </Box>

export default SearchForm
